import { NgModule } from '@angular/core';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AccountRoutingModule } from './account-routing.module';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { RouterModule } from '@angular/router';
import { SetupComponent } from './setup/setup.component';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { MatIconModule } from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { UserMaintenanceComponent } from './user-maintenance/user-maintenance.component';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    
    ReactiveFormsModule,
    AccountRoutingModule,
    FormsModule,
    FontAwesomeModule,
    MatIconModule,
    MatListModule,
    MatCheckboxModule,
    TreeViewModule
  ],
  declarations: [
    LayoutComponent,
    LoginComponent,
    SetupComponent,    
    UserMaintenanceComponent
  ]
})
export class AccountModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, far);
  }
}
